/** Shared motion tokens for admin dashboard animations */

export const motionConfig = {
    rowStagger: 0.04,
    rowDuration: 0.22,
    pageDuration: 0.25,
    pageEase: [0.22, 1, 0.36, 1] as const,
    rowEase: [0.22, 1, 0.36, 1] as const,
    rowOffsetY: 8,
    accentDuration: 300,
    card3dPerspective: 1200,
    cardHoverLift: -4,
};

export const tableBodyVariants = {
    hidden: {},
    show: {
        transition: {
            staggerChildren: motionConfig.rowStagger,
        },
    },
};

export const tableRowVariants = {
    hidden: {
        opacity: 0,
        y: motionConfig.rowOffsetY,
    },
    show: {
        opacity: 1,
        y: 0,
        transition: {
            duration: motionConfig.rowDuration,
            ease: motionConfig.rowEase,
        },
    },
};

export const rowTapTransition = { duration: 0.15, ease: motionConfig.rowEase };

export const detailPanelVariants = {
    hidden: {
        opacity: 0,
        height: 0,
    },
    show: {
        opacity: 1,
        height: 'auto',
        transition: {
            duration: 0.28,
            ease: motionConfig.rowEase,
        },
    },
};

export const pageVariants = {
    initial: { opacity: 0, y: 12, rotateX: 4, scale: 0.98 },
    animate: {
        opacity: 1,
        y: 0,
        rotateX: 0,
        scale: 1,
        transition: { duration: motionConfig.pageDuration, ease: motionConfig.pageEase },
    },
    exit: {
        opacity: 0,
        y: -8,
        rotateX: -2,
        scale: 0.99,
        transition: { duration: motionConfig.pageDuration * 0.8, ease: motionConfig.pageEase },
    },
};

export const card3dVariants = {
    hidden: {
        opacity: 0,
        y: 16,
        rotateX: 8,
        scale: 0.97,
    },
    show: {
        opacity: 1,
        y: 0,
        rotateX: 0,
        scale: 1,
        transition: {
            duration: 0.4,
            ease: motionConfig.pageEase,
        },
    },
};
